import { Box, Container, Typography } from "@material-ui/core";
import styled from "@emotion/styled";

import MainLayout from "@/layouts/MainLayout";

const BindRequestSubmittedImage = styled.img`
  max-width: 480px;
  width: 100%;
  object-fit: contain;
`;

const CenteredContainer = styled(Container)`
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BackgroundImage = styled.img`
  max-width: 50%;
  bottom: -100px;
  right: 0;
  position: absolute;
  z-index: -1;
`;

export default function BindRequestSubmitted() {
  return (
    <MainLayout
      backgroundImage={
        <BackgroundImage
          src="/images/bind_request_submitted_background_waves.png"
          alt="Bind request submitted page background waves"
        />
      }
    >
      <CenteredContainer maxWidth="sm">
        <BindRequestSubmittedImage
          src="/images/bind_request_submitted.png"
          alt="Two men shaking hands"
        />
        <Box textAlign="center" color="primary" my={4}>
          <Typography variant="h2" color="primary">
            Purchase Requested
          </Typography>
        </Box>

        <Box maxWidth="600px">
          <Typography align="center">
            We are now working to bind coverage with the carrier. We will send
            you an invoice by email, and will follow up if there are any
            additional materials required to satisfy any contingencies.
          </Typography>
        </Box>
      </CenteredContainer>
    </MainLayout>
  );
}
